import React from 'react';
import { KNOWN_COMMANDS, SLASH_COMMAND_RE } from '../../constants';
import classes from './UserMessage.module.scss';

const renderContent = (content) => {
  const match = content.match(SLASH_COMMAND_RE);
  if (!match || !KNOWN_COMMANDS.has(match[1])) return content;
  return (
    <>
      <span className={classes.Command}>{match[1]}</span>
      {match[2] ?? ''}
    </>
  );
};

const formatTimestamp = (timestamp) =>
  new Date(timestamp).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

const UserMessage = React.memo(({ message }) => {
  const { content, timestamp } = message;

  return (
    <div className={classes.Container}>
      <div className={classes.MessageWrapper}>
        <div className={classes.Bubble}>
          <p className={classes.Text}>{renderContent(content)}</p>
        </div>
        <span className={classes.Timestamp}>{formatTimestamp(timestamp)}</span>
      </div>
      <span className={classes.Avatar} aria-hidden="true">👤</span>
    </div>
  );
});

UserMessage.displayName = 'UserMessage';

export default UserMessage;
